var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiUploadLtr = function SvgUiUploadLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M70.345 28.698 52.033 10.584a1.95 1.95 0 0 0-.68-.438 2.16 2.16 0 0 0-1.562 0 1.95 1.95 0 0 0-.68.438L30.656 28.698a2.21 2.21 0 0 0-.037 3.102 2.16 2.16 0 0 0 3.074.037L48.33 17.342v55.469A2.18 2.18 0 0 0 50.5 75a2.18 2.18 0 0 0 2.17-2.19V17.343l14.638 14.495a2.16 2.16 0 0 0 3.073-.037 2.21 2.21 0 0 0-.036-3.102M83.85 86c1.187 0 2.15.895 2.15 2 0 1.085-.929 1.968-2.087 2H16.15c-1.187 0-2.15-.895-2.15-2 0-1.085.929-1.968 2.087-2z",
    clipRule: "evenodd"
  })));
};
export default SvgUiUploadLtr;